export function isPreview(url = '') {
  return Boolean(url.split('/')?.[2] === '__preview');
}
